import { render, staticRenderFns } from "./CreateEncabezado.vue?vue&type=template&id=b7658506&"
import script from "./CreateEncabezado.vue?vue&type=script&lang=js&"
export * from "./CreateEncabezado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports